import React, { ComponentType, FC, ReactNode } from 'react';

type Provider = ComponentType<{ children?: ReactNode }>;
type ProviderWithProps = {
    component: ComponentType<any>;
    props?: Record<string, any>;
};

export function composeProviders(providers: (Provider | ProviderWithProps)[]): FC<{ children?: ReactNode }> {
    return ({ children }) =>
        providers.reduceRight((acc, provider) => {
            if (typeof provider === 'function') {
                const ProviderComponent = provider;
                return <ProviderComponent>{acc}</ProviderComponent>;
            }

            const { component: ProviderComponent, props = {} } = provider;
            return <ProviderComponent {...props}>{acc}</ProviderComponent>;
        }, children as React.ReactElement);
}
